import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ProfilePageRoutingModule } from './profile-routing.module';

import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { ProfileClearDataCardComponent } from './components/profile-clear-data-card/profile-clear-data-card.component';
import { ProfileContactCardComponent } from './components/profile-contact-card/profile-contact-card.component';
import { ProfileHeaderComponent } from './components/profile-header/profile-header.component';
import { ProfileSecurityCardComponent } from './components/profile-security-card/profile-security-card.component';
import { ProfilePage } from './profile.page';

import { AcceptedFileTypesPopoverComponent } from './components/accepted-file-types-popover/accepted-file-types-popover.component';
import { CreateCustomMessageModalComponent } from './components/create-custom-message-modal/create-custom-message-modal.component';
import { CustomMessagesCardComponent } from './components/custom-messages-card/custom-messages-card.component';
import { InviteNewUserCardComponent } from './components/invite-new-user-card/invite-new-user-card.component';
import { SurveyCardComponent } from './components/profile-survey-card/survey-card.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ProfilePageRoutingModule,
    SharedModule,
    TranslateModule,
    ReactiveFormsModule,
    MatCardModule,
    MatDatepickerModule,
  ],
  declarations: [
    ProfilePage,
    ProfileHeaderComponent,
    ProfileContactCardComponent,
    ProfileSecurityCardComponent,
    ProfileClearDataCardComponent,
    CustomMessagesCardComponent,
    CreateCustomMessageModalComponent,
    AcceptedFileTypesPopoverComponent,
    InviteNewUserCardComponent,
    SurveyCardComponent,
  ],
})
export class ProfilePageModule {}
